<template>
  <v-app>
    <v-fade-transition>
      <router-view />
    </v-fade-transition>
    <v-snackbar
      :timeout="$config.snackbar.time"
      :color="$config.snackbar.color"
      v-model="$config.snackbar.show"
      class="snackbar"
    >
      {{ $config.snackbar.text }}
    </v-snackbar>
    <v-snackbar
      :value="snackbar"
      :color="snackbarVariant"
      :timeout="3000"
      @input="handleSnackbarClose"
    >
      {{ snackbarMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" icon v-bind="attrs" @click="snackbarClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <ModalTermos :disabledButton="disabledButton" />
  </v-app>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import displayHelpers from "@/mixins/breakpoints.mixins";
import ModalTermos from "@/components/global/ModalTermos.vue";
export default {
  mixins: [displayHelpers],
  components: {
    ModalTermos,
  },
  data() {
    return {
      disabledButton: true,
    };
  },
  computed: {
    ...mapState({
      snackbar: state => state.snackbar.snackbar,
      snackbarMessage: state => state.snackbar.snackbarMessage,
      snackbarVariant: state => state.snackbar.snackbarVariant,
    }),
    isAdmin() {
      if (this.$axios.getLocal("oe_user_info", true).data.user_type === "admin")
        return true;
      return false;
    },
    getHistory() {
      return this.$axios.getLocal("history").data;
    },
    isNotLoginPage() {
      return this.$route.name !== "login";
    },
  },
  watch: {
    $route(e) {
      if (this.$route.path.includes("/docs")) {
        // se a rota atual inclui "/docs", não alterar o tema dark
        return;
      } else {
        // se a rota atual não inclui "/docs", desativar o tema dark
        this.$vuetify.theme.dark = false;
      }

      if (e.name !== "login") {
        this.$axios.setLocal("history", e.path);
      }
      if (
        this.$axios.getLocal("oe_user_info") &&
        this.$axios.getCookie("oe_jwt") &&
        e.name === "login"
      ) {
        return this.$router.push(this.getHistory);
      }

      if (this.$axios.getLocal("oe_user_info").data?.user_type === "loja") {
        if (
          e.name === "redefineAdminPass" ||
          e.name === "recoveryAdminPass" ||
          e.name === "users" ||
          e.name === "userSettings" ||
          e.name === "salePoint" ||
          e.name === "salePointSettings" ||
          e.name === "salePointType" ||
          e.name === "producers" ||
          e.name === "segments" ||
          e.name === "categories" ||
          e.name === "regional" ||
          e.name === "financePaymentMethods" ||
          e.name === "equipments" ||
          e.name === "equipmentsSettings" ||
          e.name === "marketing" ||
          e.name === "termos" ||
          e.name === "configuracao-omnichannel"
        )
          return this.$router.push("/home");
      }

      if (
        e.name !== "login" &&
        this.$axios.getCookie("oe_jwt") &&
        this.$axios.getLocal("oe_user_info")
      ) {
        this.$sac.init();
      }
    },
    colorPath() {
      this.path = this.$route.name;
      if (
        (this.$route.path == "/home/" && !this.isAdmin) ||
        (this.$route.path == "/home" && !this.isAdmin)
      ) {
        return document.querySelector("#app").classList.add("base");
      }
    },
  },
  methods: {
    ...mapMutations(["snackbarClose"]),
    colorPath() {
      const path = this.$route.name;
      if (
        (path == "/home/" && !this.isAdmin) ||
        (path == "/home" && !this.isAdmin)
      ) {
        return document.querySelector("#app").classList.add("dash-color");
      }
    },
    handleSnackbarClose() {
      this.snackbarClose();
    },
  },
  mounted() {
    this.colorPath;
    window.addEventListener("scroll", this.handleScroll, true);
    if (window.scrollY <= 0) {
      this.disabledButton = false;
    }
    const isMacOS = /Mac|iPod|iPhone|iPad/.test(navigator.userAgent);
    if (isMacOS) {
      document.querySelector("#app").classList.add("mac-font");
    } else {
      document.querySelector("#app").classList.add("other-font");
    }
    if (
      (this.$route.path == "/home/" && !this.isAdmin) ||
      (this.$route.path == "/home" && !this.isAdmin)
    ) {
      return document.querySelector("#app").classList.add("dash-color");
    }
    if (this.$axios.getCookie("elevenAdminLocale")) {
      this.$i18n.locale = this.$axios.getCookie("elevenAdminLocale");
    } else {
      this.$i18n.locale = "pt_BR";
      this.$axios.setCookie("elevenAdminLocale", "pt_BR");
    }
  },
  destroyed() {
    this.colorPath;
    window.removeEventListener("scroll", this.handleScroll, true);
    document.querySelector("#app").classList.add("dash-color");
  },
};
</script>
<style scoped lang="scss">
@import url("./style.css");
@import url("./assets/css/fontes.css");
@import url("https://fonts.googleapis.com/css2?family=Archivo:wght@400;600;700&display=swap");

.snackbar {
  text-align-last: center !important;
}
.v-snack__wrapper {
  border-radius: 0.625rem !important;
}
.other-font {
  font-family: "Archivo", sans-serif;
}
.mac-font {
  font-family: sans-serif;
}
.config-button {
  position: fixed;
  right: 15px;
  bottom: 26px;
}
.dash-color {
  background-color: var(--v-base-base) !important;
  /* color: #e9e8ed !important; */
}
</style>
